import type { WidgetConfig, LayoutParams } from './types.js';

export function computeLayout(config: WidgetConfig, containerWidth: number): LayoutParams {
  // Mobile: ≤480px — force slider, 1 column, 12px gap
  if (containerWidth <= 480) {
    const gap = 12;
    return {
      layout: 'slider',
      columns: 1,
      gap,
      cardWidth: Math.max(1, containerWidth - gap * 2),
      visibleItems: 1,
    };
  }

  // Tablet: ≤768px — max 2 grid columns, 2 visible slider items, 16px gap
  if (containerWidth <= 768) {
    const gap = 16;
    const columns = Math.min(config.columns, 2);
    const layout = config.layout;
    const visibleItems = layout === 'slider' ? 2 : columns;
    const cardWidth = Math.max(1, (containerWidth - gap * (columns - 1)) / columns);
    return { layout, columns, gap, cardWidth, visibleItems };
  }

  // Desktop: >768px — full configured columns and layout, 20px gap
  const gap = 20;
  const columns = config.columns;
  const visibleItems = config.layout === 'slider' ? columns : columns;
  const cardWidth = Math.max(1, (containerWidth - gap * (columns - 1)) / columns);
  return { layout: config.layout, columns, gap, cardWidth, visibleItems };
}
